import epay from '@/services/epay'

export async function showPaymentForm(invoiceId, amount, data, description = 'Оплата в интернет магазине', callback = null, auth, terminal) {
    let paymentObject = createPaymentObject(auth, invoiceId, amount, data, description, terminal);
    epay.pay(paymentObject, callback);
}

function createPaymentObject(auth, invoiceId, amount, data, description = 'Оплата в интернет магазине', terminal) {
    let {postLink, failurePostLink, name, phone, email, accountId} = data;

    return {
        invoiceId: invoiceId,
        invoiceIdAlt: 'ALT-' + invoiceId,
        backLink: '#',
        failureBackLink: '#',
        postLink: postLink,
        failurePostLink: failurePostLink,
        language: "RUS",
        description: description,
        accountId: accountId,
        terminal: terminal,
        amount: amount,
        name: name,
        phone: phone,
        email: email,
        currency: "KZT",
        data: JSON.stringify({
            statement: {
                account: accountId,
                amount: amount,
                currency: "KZT",
                email: email,
                phone: phone,
                name: name,
                invoiceID: invoiceId
            }
        }),
        cardSave: true,
        auth: auth
    };
}
